import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { timezoneToString } from 'modules/core/lib/timezones'

import { useShiftTimeFormatted } from 'modules/shift_management/hooks/useShiftTimeFormatted'
import { getColor } from 'modules/shift_management/lib/getColor'

interface Props {
  title: string
  color: string | null
  startAt: string
  endAt: string
  overnightShift: boolean
  timezone?: string | null
  children?: React.ReactNode
}

const SavedShiftInformation = ({
  title,
  color,
  startAt,
  endAt,
  overnightShift,
  timezone,
  children,
}: Props) => {
  const formatShiftTime = useShiftTimeFormatted()
  const shiftTimezone = timezone ? timezoneToString(timezone) : null

  return (
    <Box flexDirection="row" gap="s12" overflowX="hidden">
      <Box
        borderRadius={{ all: 'abs008' }}
        minHeight="s40"
        width="s6"
        flexGrow
        background={getColor(color)}
      />
      <Box gap="s2" alignItems="flexStart" textAlign="left" maxWidth="full" paddingRight="s6">
        <Text size="200" weight="semibold" color="grey1000" ellipsis>
          {title}
        </Text>
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Text size="200" weight="medium" color="grey1000">
            {formatShiftTime(startAt, endAt)}
          </Text>
          {overnightShift && (
            <Text size="200" weight="medium" color="grey1000">
              {i18n.t('shift_management.plus_1_day_tag')}
            </Text>
          )}
        </Box>
        {shiftTimezone && (
          <Text size="200" weight="medium" color="grey1000" ellipsis>
            {shiftTimezone}
          </Text>
        )}
        {children}
      </Box>
    </Box>
  )
}

export default SavedShiftInformation
